import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
// # models
import { PlanModel } from '@/models';
// # components
import { EditPlan } from '@/components/plans';
import Modal from '@/components/modal';
// # services
import { route } from '@/services';

export interface iProps {
    onPlanChange?: (plan: PlanModel) => any;
}

/**
 * Sets up the routes handled by the admin plans scene.
 * Also renders children so they can inherit route context.
 */
const AdminPlansSceneRouter: React.SFC<iProps> = (props: iProps) => (
    <Switch>
        <Route
            path={route('admin.plans.edit').path}
            render={({ history, match }) => (
                <Modal
                    onClose={() => {
                        history.push(route('admin.plans').make());
                    }}
                    title="Edit Plan"
                >
                    <EditPlan id={Number(match.params.id)} onChange={props.onPlanChange} />
                </Modal>
            )}
        />
        <Route
            path={route('admin.plans.new').path}
            render={({ history }) => (
                <Modal
                    onClose={() => {
                        history.push(route('admin.plans').make());
                    }}
                    title="New Plan"
                >
                    <EditPlan onChange={props.onPlanChange} />
                </Modal>
            )}
        />
    </Switch>
);

export default AdminPlansSceneRouter;

